import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  //
  addPackageSuccess,
  addPackageFailure,
  //
  deletePackageSuccess,
  deletePackageFailure,
  //
  editPackageSuccess,
  editPackageFailure,
  //
  fetchPackages as fetchPackagesAction,
  fetchPackagesFailure,
  fetchPackagesSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_PACKAGE,
  DELETE_PACKAGE,
  EDIT_PACKAGE,
  FETCH_PACKAGES,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchPackagesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/package?${query}`);
    yield put(fetchPackagesSuccess(data));
  } catch (e) {
    yield put(fetchPackagesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching packages!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/package/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addPackageSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/package/add`, payload.data);
    if (data) {
      yield put(successAlert("Package added successfully!"));
      yield put(addPackageSuccess());
      if (payload?.history) {
        payload.history.push("/d/packages");
      }
    }
  } catch (e) {
    yield put(addPackageFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editPackageSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/package/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Package updated successfully!"));
      yield put(editPackageSuccess());
      yield put(getViewDataAction(payload.data.id));
    }
  } catch (e) {
    yield put(editPackageFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deletePackageSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/package/${payload}`);
    if (data) {
      yield put(successAlert("Package deleted successfully!"));
      yield put(deletePackageSuccess());
      yield put(fetchPackagesAction());
    }
  } catch (e) {
    yield put(deletePackageFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchPackagesFlow() {
  yield takeEvery(FETCH_PACKAGES, fetchPackagesSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addPackageFlow() {
  yield takeEvery(ADD_PACKAGE, addPackageSaga);
}
export function* editPackageFlow() {
  yield takeEvery(EDIT_PACKAGE, editPackageSaga);
}
export function* deletePackageFlow() {
  yield takeEvery(DELETE_PACKAGE, deletePackageSaga);
}

export default function* PackageSaga() {
  yield all([
    fetchPackagesFlow(),
    addPackageFlow(),
    editPackageFlow(),
    deletePackageFlow(),
    getViewDataFlow(),
  ]);
}
